<div *ngIf="gameService.showEndDatePicker.value" class="date-picker">
  <div class="title">Wanneer mag je beginnen?</div>
  <div class="start">
    <ion-datetime
      (ionChange)="gameService?.setStartDateOrEndDate(null, endDate)"
      [(ngModel)]="endDate"
      [presentation]="'date'"
      [showDefaultTimeLabel]="false"
    ></ion-datetime>
  </div>
  <div class="buttons">
    <button (click)="hideDatePicker()" class="close-button">
      <img alt="arrow left" src="../../../../assets/icons/arrow-left.svg" />
      Terug
    </button>

    <button
      (click)="
        gameService.determineDayDifferenceFromStartDate();
        gameService.setTrainWidthBasedOnDateDifference();
        gameService.turnOnShowWelcome();
        gameService.buildDateRange();
        hideDatePicker()
      "
      *ngIf="endDate !== null"
      class="close-button"
    >
      Klaar
      <img alt="arrow button" src="../../../../assets/icons/white-arrow-button-right.svg" />
    </button>
  </div>
</div>
